/**
 * @author: Sarfraj Khan | 22-aug-2024
 */
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Col, Row, Form, Table, Button } from "react-bootstrap";
import schoolApi from "../../api/schoolApi";
import InfoPill from "../InfoPill";
import { ToastContainer, toast } from "react-toastify";

const Promotion = ({ props }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [allClasses, setAllClasses] = useState([]);
  const [students, setStudents] = useState([]);
  const [classSection, setClassSection] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [feeTypeOptions, setFeeTypeOptions] = useState([]);
  const [promoteSection, setPromotionSection] = useState([]);
  const [isNexButton, setIsNextBtton] = useState(true);
  const [promotionData, setPromotionData] = useState({
    current_class: location.state.class_id,
  });
  const [globalSessionId, setGlobalSessionId] = useState();
  const [feeStructure, setFeeStructure] = useState([]);
  const [sessionDates, setSessionDates] = useState({});
  const [showUpComingFields, setShowUpComingFields] = useState(false);
  const [sectionByInlineClassId, setSectionByInlineClassId] = useState([]);
  const [currentSessionRecord, setCurrentSessionRecord] = useState();
  const [promotedClasses, setPromotedClasses] = useState();

  useEffect(() => {
    fetchSessions();
    if (allClasses.length === 0) {
      schoolApi
        .getActiveClassRecords()
        .then((result) => {
          if (result.success) {
            setAllClasses(result.result);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
    fetchSectionByClassId(location?.state?.class_id);
  }, []);

  useEffect(() => {
    setStudents([]); // Added By mohd. sarfraj | 14-sept.2024.  {when ever current class changed then student state should be empty. }
    setGlobalSessionId(""); // Added By mohd. sarfraj | 14-sept.2024.  {when ever current class changed then globalSessionId should be empty. }
    fetchSectionByClassId(promotionData.current_class); // fatch section according class id
  }, [promotionData.current_class]);

  const fetchClassesByOldFeeMasterAndSessionId = async (sessionid) => {
    try {
      const response = await schoolApi.getPromotedActiveClasses(sessionid);
      console.log("promotedClass-->>", response);
      if (response.success) {
        setPromotedClasses(response.result);
      } else {
        setPromotedClasses([]);
      }
    } catch (error) {
      setPromotedClasses([]);
    }
  };

  const handleStudentRecordsGet = async () => {
    if (
      promotionData.current_class &&
      promotionData.current_section &&
      promotionData.current_session
    ) {
      await schoolApi
        .getAllStudentByClassidFeeData({
          classid: promotionData.current_class,
          session_id: promotionData.current_session,
          section_id: promotionData.current_section,
        })
        .then(async (res) => {
          if (res.success) {
            const currentClass = allClasses?.find(
              (item) => item.id === promotionData?.current_class
            );
            const currentSection = classSection?.find(
              (item) => item.id === promotionData?.current_section
            );
            const currentSession = sessions?.find(
              (item) => item?.id === promotionData.current_session
            );

            // console.log('res?.result-->>' , res?.result);
            const filteredStudent = res?.result?.filter(
              (obj) =>
                obj?.droptout_status !== "dropout" &&
                obj?.promotion_status !== "promoted"
            );
            // console.log('filteredStudent-->>' , filteredStudent);

            if (res?.result?.length > 0 && filteredStudent?.length === 0) {
              return toast.error(
                `Student of ${currentClass?.class_name}[${currentSection?.name}], Session ${currentSession?.year}, already promoted!`
              );
            }

            setStudents(
              filteredStudent?.map((obj) => ({
                ...obj,
                isPromote: true,
                isDropout: false,
              }))
            );
            setShowUpComingFields(true);
          } else {
            setStudents([]);
            return toast.success("No Records Found");
          }
        })
        .catch((err) => {
          console.error("promotion error-->", err);
          setStudents([]);
          return toast.error("No record found");
        });
    } else {
      toast.error("Fill all required field.");
    }
  };

  const fetchSectionByClassId = async (id) => {
    try {
      const result = await schoolApi.getSectionRecordById(
        id || location.state.promotionRecord[0]?.class_id
      );
      if (result.success) setClassSection(result.record);
    } catch (error) {
      console.log("error--during-get-classSection-byId--> ", error);
    }
  };

  const fetchSessions = async () => {
    const res = await schoolApi.getAllSession();

    if (res.success) {
      const date = new Date();
      let currentyear = date.getFullYear();
      const sessions = [];
      for (let i = 0; i < res?.result?.length; i++) {
        if (
          currentyear == res?.result[i]?.startdate.substring(0, 4) ||
          currentyear + 1 == res?.result[i]?.startdate.substring(0, 4) ||
          currentyear - 1 == res?.result[i]?.startdate.substring(0, 4)
        ) {
          sessions.push(res?.result[i]);
        }
      }

      const currentDate = new Date();
      const fetchSelectedSessionResult = sessions?.find((res) => {
        const startDate = new Date(res.startdate);
        const endDate = new Date(res.enddate);
        return currentDate >= startDate && currentDate <= endDate;
      });
      setSessions(sessions);
      setCurrentSessionRecord(fetchSelectedSessionResult);
      setPromotionData({
        ...promotionData,
        current_session: fetchSelectedSessionResult?.id,
      });
    }
  };

  const handleChange1 = async (e) => {
    const name = e.target.name;

    if (e.target.name === "current_class") {
      promotionData.current_section = "";
      setStudents([]);
    } else if (e.target.name === "current_session") {
      setShowUpComingFields(false);
      setGlobalSessionId(null);
      setStudents([]);
    } else if (e.target.name === "current_section") {
      setStudents([]);
    }
    setPromotionData({ ...promotionData, [name]: e.target.value });
  };

  const handleStudentDropOutStatus = (row, promoteStatus) => {
    const updatedStudents = students.map((student) =>
      student?.student_admission_id === row?.student_admission_id
        ? { ...student, isDropout: promoteStatus }
        : student
    );
    setStudents(updatedStudents);
  };

  const handleCheckbox = async (e, row) => {
    try {
      const { checked, name } = e.target;
      console.log("checked-->>", checked);
      console.log("name-->>", name);

      let updatedStudents = null;

      if (name === "Master_checkbox") {
        if (students.some((student) => student?.isPromote === false)) {
          updatedStudents = students.map((student) =>
            student?.isPromote === false
              ? {
                  ...student,
                  isPromote: checked,
                  classname: promotedClasses?.find(
                    (obj) => obj?.id === student?.promoted_class_id
                  )?.class_name,
                  class_id: promotedClasses?.find(
                    (obj) => obj?.id === student?.promoted_class_id
                  )?.id,
                  classid: "",
                  section_id: promoteSection?.find(
                    (obj) =>
                      obj?.class_id === student?.promoted_class_id &&
                      obj?.id === student?.promoted_section_id
                  )?.id,
                  section_name: promoteSection?.find(
                    (obj) =>
                      obj?.class_id === student?.promoted_class_id &&
                      obj?.id === student?.promoted_section_id
                  )?.name,
                  updated_row_section: null,
                }
              : student
          );
          // setClassSection([]);
        } else {
          updatedStudents = students.map((student) => ({
            ...student,
            isPromote: checked,
            class_id: promotionData?.current_class,
            classname: allClasses?.find(
              (classItem) => classItem?.id === promotionData?.current_class
            )?.class_name,
            section_id: location.state.section.find(
              (section) =>
                promotionData?.current_section === section?.section_id
            )?.section_id,
            section_name: location.state.section.find(
              (section) =>
                promotionData?.current_section === section?.section_id
            )?.section_name,
          }));
        }
      } else {
        if (checked === false) {
          const specific_class_section = await schoolApi.getSectionRecordById(
            promotionData?.current_class
          );
          console.log("Failed-student-section-->>", specific_class_section);

          let feeMasterResult =
            await schoolApi.fetchPromotionFeeMasterByIdOrClassid(
              promotionData?.current_class,
              globalSessionId
            );
          console.log("feeMasterResult", feeMasterResult);

          // if(!feeMasterResult.success){
          //   return toast.error('Create fee master record for selected class');
          // }

          const finalData = await schoolApi.getFinalDataByClassAndSesionId(
            promotionData?.current_class,
            globalSessionId
          );
          console.log("finalData-->>>", finalData);

          if (finalData?.record[0]?.feeStructure !== null) {
            const promotedSessionRecord = sessions.find(
              (session) => session.id === globalSessionId
            );
            const startdate = promotedSessionRecord?.startdate;
            const enddate = promotedSessionRecord?.enddate;

            const startDate = new Date(startdate);
            const endDate = new Date(enddate);

            if (startDate && endDate) {
              generateInstallmentDates(startDate, endDate);
            }

            let pendingDueResult = [];
            const ResultSettings = await schoolApi.getSettingByKey(
              "pending_due_day"
            );
            if (ResultSettings.success) {
              pendingDueResult.push(ResultSettings.data[0]);
            } else {
              pendingDueResult([]);
            }

            const classWiseStructure = finalData?.record[0]?.fee_structure;
            let upcomingInstallments = [];

            classWiseStructure?.map((res) => {
              let typeWiseInstallments = [];
              res.installments.map((item) => {
                let splittedMonth = item?.month?.split(" ");
                let lastDate = new Date(sessionDates[splittedMonth[0]]);
                if (pendingDueResult[0].value) {
                  lastDate.setDate(pendingDueResult[0].value);
                }
                let installmentDate = lastDate.toISOString().slice(0, 10);

                typeWiseInstallments.push({
                  fee_master_installment_id: item.installment_id,
                  month: item.month,
                  general_fee: item.general_fee,
                  obc_fee: item.obc_fee,
                  sc_fee: item.sc_fee,
                  st_fee: item.st_fee,
                  due_date: installmentDate,
                  line_items: item.line_items,
                });
              });

              console.log("typeWiseInstallments-->", typeWiseInstallments);
              upcomingInstallments.push({
                type: res.type,
                value: typeWiseInstallments,
              });
            });
            feeStructure.push({
              key: promotionData?.current_class,
              value: upcomingInstallments,
            });
          } else {
            return toast.error("Create fee head-masters first..!!");
          }

          const newSt = await Promise.all(
            students.map(async (prevSt) => {
              console.log("prevSt-->>", prevSt);
              console.log(
                " prevSt.student_admission_id-->>>",
                prevSt.student_admission_id
              );
              console.log(
                " row.student_admission_id",
                row.student_admission_id
              );

              const selectedSt =
                prevSt.student_admission_id === row.student_admission_id &&
                prevSt;
              console.log("selectedSt-->", selectedSt);

              if (selectedSt) {
                const feeMatch = feeMasterResult.result?.find(
                  (obj) => obj?.type === selectedSt?.fee_type
                );
                console.log("feeMatch-->>", feeMatch);

                if (!feeMatch) {
                  toast.error("Create a fee master for the next session!");
                  return prevSt;
                }

                let feeCategory = "";
                let categoryAmount = "";
                switch (selectedSt?.category) {
                  case "General":
                    feeCategory = "general_fee";
                    categoryAmount = "general_amount";
                    break;
                  case "Obc":
                    feeCategory = "obc_fee";
                    categoryAmount = "obc_amount";
                    break;
                  case "Sc":
                    feeCategory = "sc_fee";
                    categoryAmount = "sc_amount";
                    break;
                  case "St":
                    feeCategory = "st_fee";
                    categoryAmount = "st_amount";
                    break;
                  default:
                    feeCategory = "general_fee";
                    categoryAmount = "general_amount";
                    break;
                }

                // Fetch discount for the student
                const discount = await getdiscount(
                  selectedSt.student_admission_id
                );
                console.log("discount-->>", discount);

                const studentInstallments =
                  feeStructure
                    .find((str) => {
                      return str.key === promotionData?.current_class;
                    })
                    ?.value?.find((res) => res.type === selectedSt.fee_type)
                    ?.value || [];

                // Map the installments to apply the discount
                const new_installments = studentInstallments.map(
                  (installment, i) => {
                    let discountedAmount = 0;

                    discount?.forEach((dis) => {
                      const discountFeeHeadId = dis?.fee_head_id;
                      const discountPercent = parseInt(dis?.percent) || 0;
                      const discountAmount = parseInt(dis?.amount) || 0;

                      let feeHeadIds = discountFeeHeadId;
                      if (typeof feeHeadIds === "string") {
                        try {
                          feeHeadIds = JSON.parse(feeHeadIds);
                        } catch (e) {
                          if (feeHeadIds.startsWith("{") && feeHeadIds.endsWith("}")) {
                            feeHeadIds = feeHeadIds.slice(1, -1).split(",").map(s => s.trim());
                          } else {
                            feeHeadIds = [feeHeadIds.trim()];
                          }
                        }
                      }
                      if (!Array.isArray(feeHeadIds)) {
                        feeHeadIds = feeHeadIds ? [feeHeadIds] : [];
                      }
                      feeHeadIds = feeHeadIds
                        .map(id => (typeof id === "object" && id !== null ? (id.fee_head_id || id.id || id.value) : id))
                        .filter(id => {
                          const s = String(id || "").trim();
                          return s !== "" && s !== "null" && s !== "{}" && s !== "undefined";
                        });

                      const hasSpecificHeads = feeHeadIds.length > 0;
                      let lineItemAmountByCategory = 0;
                      let applicableDiscount = 0;

                      if (hasSpecificHeads) {
                        const matchedItems = (installment?.line_items || []).filter((li) =>
                          feeHeadIds.some((fId) => String(fId) === String(li.fee_head_master_id || li.fee_head_id))
                        );
                        if (matchedItems.length > 0) {
                          lineItemAmountByCategory = matchedItems.reduce(
                            (sum, item) => sum + (parseInt(item[categoryAmount] || item.amount || 0) || 0),
                            0
                          );
                          if (lineItemAmountByCategory > 0) {
                            if (discountAmount > 0) {
                              applicableDiscount = Math.min(discountAmount, lineItemAmountByCategory);
                            } else if (discountPercent > 0) {
                              applicableDiscount = Math.round((lineItemAmountByCategory * discountPercent) / 100);
                            }
                          }
                        }
                      } else {
                        lineItemAmountByCategory = (installment?.line_items || []).reduce(
                          (sum, item) => sum + (parseInt(item[categoryAmount] || item.amount || 0) || 0),
                          0
                        );
                        if (lineItemAmountByCategory > 0) {
                          if (discountAmount > 0) {
                            applicableDiscount = Math.min(discountAmount, lineItemAmountByCategory);
                          } else if (discountPercent > 0) {
                            applicableDiscount = Math.round((lineItemAmountByCategory * discountPercent) / 100);
                          }
                        }
                      }

                      discountedAmount += applicableDiscount;
                    });

                    const maxDiscount = parseInt(installment[feeCategory] || 0);
                    discountedAmount = Math.min(maxDiscount, discountedAmount);

                    return {
                      orderno: i + 1,
                      amount: installment[feeCategory],
                      status: "pending",
                      due_date: installment.due_date,
                      month: installment.month,
                      fee_master_installment_id:
                        installment.fee_master_installment_id,
                      session_id: globalSessionId,
                      installment_discount: discountedAmount,
                    };
                  }
                );
                console.log("new_installments-->>", new_installments);

                return prevSt.student_admission_id ===
                  row?.student_admission_id && row?.isPromote === true
                  ? {
                      ...prevSt,
                      class_id: promotionData?.current_class,
                      classname: allClasses?.find(
                        (classItem) =>
                          classItem?.id === promotionData?.current_class
                      )?.class_name,
                      section_id: location.state.section.find(
                        (section) =>
                          promotionData?.current_section === section?.section_id
                      )?.section_id,
                      section_name: location.state.section.find(
                        (section) =>
                          promotionData?.current_section === section?.section_id
                      )?.section_name,
                      fee_id: feeMatch?.id,
                      fee_type: feeMatch?.type,
                      isPromote: checked,
                      installments: new_installments,
                      updated_row_section: specific_class_section?.record, // this key changes the section drop-down according to class_id.(in-line)
                    }
                  : prevSt;
              }
              return prevSt;
            })
          );
          console.log("newSt-->>", newSt);
          // setStudents(newSt);
          updatedStudents = newSt;
          //end--------------code pawan -----------------------
        } else {
          updatedStudents = students.map((student) =>
            student?.student_admission_id === row?.student_admission_id
              ? {
                  ...student,
                  isPromote: checked,
                  classname: promotedClasses?.find(
                    (obj) => obj?.id === student?.promoted_class_id
                  )?.class_name,
                  class_id: promotedClasses?.find(
                    (obj) => obj?.id === student?.promoted_class_id
                  )?.id,
                  classid: "",
                  section_id: promoteSection?.find(
                    (obj) =>
                      obj?.class_id === student?.promoted_class_id &&
                      obj?.id === student?.promoted_section_id
                  )?.id,
                  section_name: promoteSection?.find(
                    (obj) =>
                      obj?.class_id === student?.promoted_class_id &&
                      obj?.id === student?.promoted_section_id
                  )?.name,
                  updated_row_section: null,
                }
              : student
          );
        }
        console.log("updatedStudents----->>>>>", updatedStudents);
        // return updatedStudents;
      }
      setStudents(updatedStudents);
    } catch (error) {
      console.log("Error-while-handleCheckBox-->>", error);
      return toast.error(error?.response?.data?.message);
    }
  };

  const handleSection = async (e, student_admission_id) => {
    try {
      let updatedStudents = null;

      if (e.target.name === "prmotion_section") {
        updatedStudents = students?.map((prev) =>
          prev?.isPromote === true
            ? {
                ...prev,
                section_id: e.target.value,
                section_name:
                  promoteSection?.find(
                    (section) => e.target.value === section.id
                  )?.name ||
                  classSection?.find((section) => e.target.value === section.id)
                    ?.name,
                updated_row_section: null,
                promoted_section_id: e.target.value,
                promoted_section_name:
                  promoteSection?.find(
                    (section) => e.target.value === section.id
                  )?.name ||
                  classSection?.find((section) => e.target.value === section.id)
                    ?.name,
              }
            : {
                ...prev,
                promoted_section_id: e.target.value,
                promoted_section_name:
                  promoteSection?.find(
                    (section) => e.target.value === section.id
                  )?.name ||
                  classSection?.find((section) => e.target.value === section.id)
                    ?.name,
              }
        );
      } else {
        updatedStudents = students?.map((prev) =>
          prev?.student_admission_id === student_admission_id
            ? {
                ...prev,
                section_id: e.target.value,
                section_name:
                  promoteSection?.find(
                    (section) => e.target.value === section.id
                  )?.name ||
                  sectionByInlineClassId?.sections?.find(
                    (section) => e.target.value === section.id
                  )?.name ||
                  classSection?.find((section) => e.target.value === section.id)
                    ?.name,
              }
            : prev
        );
      }
      console.log("updatedStudents-->>", updatedStudents);

      setStudents(updatedStudents);
    } catch (error) {}
  };

  const handleSession = (e) => {
    setGlobalSessionId(e.target.value);
    fetchClassesByOldFeeMasterAndSessionId(e.target.value);
    const updatesStudetnWithSessionId = students.map((prev) => ({
      ...prev,
      sessionid: e.target.value,
      isSessionId: true,
    }));
    console.log(
      "sarfraj track here updatesStudetnWithSessionId-->>",
      updatesStudetnWithSessionId
    );
    setStudents(updatesStudetnWithSessionId);
  };

  const handleClass = async (obj, student_admission_id, target_name) => {
    try {
      if (!globalSessionId) {
        return toast.error("Fill all required feild.");
      }
      // console.log("student_admission_id-sf->>", student_admission_id, obj);

      const specific_class_section = await schoolApi.getSectionRecordById(
        obj?.id
      );
      // setSectionByInlineClassId(specific_class_section?.record);
      setSectionByInlineClassId((prev) => ({
        ...prev,
        sections: [
          ...(prev.sections || []),
          ...(specific_class_section?.record || []),
        ],
      }));

      console.log(
        "ssarfraj track here pecific_class_section",
        specific_class_section
      );

      let feeMasterResult =
        await schoolApi.fetchPromotionFeeMasterByIdOrClassid(
          obj?.id,
          globalSessionId
        );
      console.log("feeMasterResult", feeMasterResult);

      const finalData = await schoolApi.getFinalDataByClassAndSesionId(
        obj?.id,
        globalSessionId
      );
      console.log("finalData-->>>", finalData);

      let updatedStudents = null;
      if (target_name === "each_class_id") {
        if (finalData?.record[0]?.feeStructure !== null) {
          const promotedSessionRecord = sessions.find(
            (session) => session.id === globalSessionId
          );
          const startdate = promotedSessionRecord?.startdate;
          const enddate = promotedSessionRecord?.enddate;

          const startDate = new Date(startdate);
          const endDate = new Date(enddate);

          if (startDate && endDate) {
            generateInstallmentDates(startDate, endDate);
          }

          let pendingDueResult = [];
          const ResultSettings = await schoolApi.getSettingByKey(
            "pending_due_day"
          );
          if (ResultSettings.success) {
            pendingDueResult.push(ResultSettings.data[0]);
          } else {
            pendingDueResult([]);
          }

          const classWiseStructure = finalData?.record[0]?.fee_structure;
          let upcomingInstallments = [];

          classWiseStructure?.map((res) => {
            let typeWiseInstallments = [];
            res.installments.map((item) => {
              let splittedMonth = item?.month?.split(" ");
              let lastDate = new Date(sessionDates[splittedMonth[0]]);
              if (pendingDueResult[0].value) {
                lastDate.setDate(pendingDueResult[0].value);
              }
              let installmentDate = lastDate.toISOString().slice(0, 10);

              typeWiseInstallments.push({
                fee_master_installment_id: item.installment_id,
                month: item.month,
                general_fee: item.general_fee,
                obc_fee: item.obc_fee,
                sc_fee: item.sc_fee,
                st_fee: item.st_fee,
                due_date: installmentDate,
                line_items: item.line_items,
              });
            });

            console.log("typeWiseInstallments-->", typeWiseInstallments);
            upcomingInstallments.push({
              type: res.type,
              value: typeWiseInstallments,
            });
          });

          feeStructure.push({ key: obj?.id, value: upcomingInstallments });
        } else {
          return toast.error("Create fee head-masters first..!!");
        }

        updatedStudents = await Promise.all(
          students.map(async (prev) => {
            const selectedSt =
              prev.student_admission_id === student_admission_id && prev;
            console.log("selectedSt-->", selectedSt);

            if (selectedSt) {
              const feeMatch = feeMasterResult.result?.find(
                (obj) => obj?.type === selectedSt?.fee_type
              );
              console.log("feeMatch-->>", feeMatch);

              if (!feeMatch) {
                toast.error("Create a fee master for the next session!");
                return prev;
              }

              let feeCategory = "";
              let categoryAmount = "";
              if (prev?.category === "General") {
                feeCategory = "general_fee";
                categoryAmount = "general_amount";
              } else if (prev?.category === "Obc") {
                feeCategory = "obc_fee";
                categoryAmount = "obc_amount";
              } else if (prev?.category === "Sc") {
                feeCategory = "sc_fee";
                categoryAmount = "sc_amount";
              } else if (prev?.category === "St") {
                feeCategory = "st_fee";
                categoryAmount = "st_amount";
              }

              const discount = await getdiscount(prev.student_admission_id);
              console.log("discount-->>", discount);

              const studentInstallments =
                feeStructure
                  .find((str) => {
                    if (str.key === obj.id) {
                      const matchedInstallment = str?.value?.find(
                        (res) => res.type === prev.fee_type
                      );
                      return matchedInstallment ? true : false;
                    }
                    return false;
                  })
                  ?.value?.find((res) => res.type === prev.fee_type)?.value ||
                [];

              let new_installments = studentInstallments.map(
                (installment, i) => {
                  let discountedAmount = 0;
                  discount?.forEach((dis) => {
                    let discountFeeHeadId = dis?.fee_head_id;
                    let discountPercent = parseInt(dis?.percent) || 0;
                    let discountAmount = parseInt(dis?.amount) || 0;

                    let feeHeadIds = discountFeeHeadId;
                    if (typeof feeHeadIds === "string") {
                      try {
                        feeHeadIds = JSON.parse(feeHeadIds);
                      } catch (e) {
                        if (feeHeadIds.startsWith("{") && feeHeadIds.endsWith("}")) {
                          feeHeadIds = feeHeadIds.slice(1, -1).split(",").map(s => s.trim());
                        } else {
                          feeHeadIds = [feeHeadIds.trim()];
                        }
                      }
                    }
                    if (!Array.isArray(feeHeadIds)) {
                      feeHeadIds = feeHeadIds ? [feeHeadIds] : [];
                    }
                    feeHeadIds = feeHeadIds
                      .map(id => (typeof id === "object" && id !== null ? (id.fee_head_id || id.id || id.value) : id))
                      .filter(id => {
                        const s = String(id || "").trim();
                        return s !== "" && s !== "null" && s !== "{}" && s !== "undefined";
                      });

                    const hasSpecificHeads = feeHeadIds.length > 0;
                    let lineItemAmountByCategory = 0;
                    let applicableDiscount = 0;

                    if (hasSpecificHeads) {
                      const matchedItems = (installment?.line_items || []).filter((li) =>
                        feeHeadIds.some((fId) => String(fId) === String(li.fee_head_master_id || li.fee_head_id))
                      );
                      if (matchedItems.length > 0) {
                        lineItemAmountByCategory = matchedItems.reduce(
                          (sum, item) => sum + (parseInt(item[categoryAmount] || item.amount || 0) || 0),
                          0
                        );
                        if (lineItemAmountByCategory > 0) {
                          if (discountAmount > 0) {
                            applicableDiscount = Math.min(discountAmount, lineItemAmountByCategory);
                          } else if (discountPercent > 0) {
                            applicableDiscount = Math.round((lineItemAmountByCategory * discountPercent) / 100);
                          }
                        }
                      }
                    } else {
                      lineItemAmountByCategory = (installment?.line_items || []).reduce(
                        (sum, item) => sum + (parseInt(item[categoryAmount] || item.amount || 0) || 0),
                        0
                      );
                      if (lineItemAmountByCategory > 0) {
                        if (discountAmount > 0) {
                          applicableDiscount = Math.min(discountAmount, lineItemAmountByCategory);
                        } else if (discountPercent > 0) {
                          applicableDiscount = Math.round((lineItemAmountByCategory * discountPercent) / 100);
                        }
                      }
                    }

                    discountedAmount += applicableDiscount;
                  });

                  const maxDiscount = parseInt(installment[feeCategory] || 0);
                  discountedAmount = Math.min(maxDiscount, discountedAmount);

                  console.log("discountedAmount--->>>", discountedAmount);

                  return {
                    orderno: i + 1,
                    amount: installment[feeCategory],
                    status: "pending",
                    due_date: installment.due_date,
                    month: installment.month,
                    fee_master_installment_id:
                      installment.fee_master_installment_id,
                    session_id: globalSessionId,
                    installment_discount: discountedAmount,
                  };
                }
              );

              console.log("new_installments==>>>", new_installments);

              return prev?.isPromote === true &&
                prev?.student_admission_id === student_admission_id
                ? {
                    ...prev,
                    class_id: obj?.id,
                    classname: obj?.class_name,
                    updated_row_section: specific_class_section?.record,
                    fee_id: feeMatch?.id,
                    fee_type: feeMatch?.type,
                    installments: new_installments,
                  }
                : prev;
            }
            return prev;
          })
        );
      }
      console.log(
        "inline-class-section-for-particular-stu-->> ",
        updatedStudents
      );
      if (updatedStudents.some((student) => student === null)) {
        setStudents(students); // Set old records as it is.
        return toast.error("Create fee master records first!!!");
      } else {
        setIsNextBtton(false);
        setStudents(updatedStudents);
      }
    } catch (error) {
      return toast.error(error.response.data.message);
    }
  };

  const handleSetPromoteCls = async (val) => {
    try {
      const promoteSections = await schoolApi.getSectionRecordById(val?.id);
      console.log("promoteSections", promoteSections);
      if (promoteSections?.success) {
        setPromotionSection(promoteSections?.record);
      }

      let feeMasterResult =
        await schoolApi.fetchPromotionFeeMasterByIdOrClassid(
          val?.id,
          globalSessionId
        );
      console.log("feeMasterResult", feeMasterResult);

      if (feeMasterResult.success) {
        setFeeTypeOptions(feeMasterResult.result);
      } else {
        return toast.error("Create fee master record first.");
      }

      const finalData = await schoolApi.getFinalDataByClassAndSesionId(
        val?.id,
        globalSessionId
      );
      console.log("finalData-->", finalData);

      if (finalData?.record[0]?.fee_structure !== null) {
        const promotedSessionRecord = sessions.find(
          (session) => session.id === globalSessionId
        );
        const startdate = promotedSessionRecord?.startdate;
        const enddate = promotedSessionRecord?.enddate;

        const startDate = new Date(startdate);
        const endDate = new Date(enddate);

        if (startDate && endDate) {
          generateInstallmentDates(startDate, endDate);
        }

        let pendingDueResult = [];
        const ResultSettings = await schoolApi.getSettingByKey(
          "pending_due_day"
        );
        if (ResultSettings.success) {
          pendingDueResult.push(ResultSettings.data[0]);
        } else {
          pendingDueResult([]);
        }

        const classWiseStructure = finalData?.record[0]?.fee_structure;
        let upcomingInstallments = [];

        classWiseStructure?.map((res) => {
          let typeWiseInstallments = [];
          res.installments.map((item) => {
            let splittedMonth = item?.month?.split(" ");
            let lastDate = new Date(sessionDates[splittedMonth[0]]);
            if (pendingDueResult[0].value) {
              lastDate.setDate(pendingDueResult[0].value);
            }
            let installmentDate = lastDate.toISOString().slice(0, 10);

            typeWiseInstallments.push({
              fee_master_installment_id: item.installment_id,
              month: item.month,
              general_fee: item.general_fee,
              obc_fee: item.obc_fee,
              sc_fee: item.sc_fee,
              st_fee: item.st_fee,
              due_date: installmentDate,
              line_items: item.line_items,
            });
          });

          console.log("typeWiseInstallments-->", typeWiseInstallments);
          upcomingInstallments.push({
            type: res.type,
            value: typeWiseInstallments,
          });
        });
        feeStructure.push({ key: val?.id, value: upcomingInstallments });
      }
      // else { // added by mohd. sarfraj | 11-sept-2024
      //   return toast.error("Records Not Found...!!!!");
      // }
      console.log("fee-structure-->>", feeStructure);

      let updatedSelecteStudents = await Promise.all(
        students.map(async (prev) => {
          // if(prev?.result === "pass"){
          console.log("prev-->>", prev);
          console.log("feeMasterResult-->>", feeMasterResult);

          const feeMatch = feeMasterResult?.result?.find(
            (obj) => obj?.type === prev?.fee_type
          );
          console.log("feeMatch-->>", feeMatch);

          if (!feeMatch) {
            return null;
          }

          let feeCategory = "";
          let categoryAmount = "";
          if (prev?.category === "General") {
            feeCategory = "general_fee";
            categoryAmount = "general_amount";
          } else if (prev?.category === "Obc") {
            feeCategory = "obc_fee";
            categoryAmount = "obc_amount";
          } else if (prev?.category === "Sc") {
            feeCategory = "sc_fee";
            categoryAmount = "sc_amount";
          } else if (prev?.category === "St") {
            feeCategory = "st_fee";
            categoryAmount = "st_amount";
          }
          console.log("categoryAmount-->>", categoryAmount);

          const discount = await getdiscount(prev.student_admission_id);
          console.log("discount-->>", discount);

          const studentInstallments =
            feeStructure
              .find((str) => {
                if (str.key === val.id) {
                  const matchedInstallment = str?.value?.find(
                    (res) => res.type === prev.fee_type
                  );
                  return matchedInstallment ? true : false;
                }
                return false;
              })
              ?.value?.find((res) => res.type === prev.fee_type)?.value || [];

          console.log("studentInstallments-->>", studentInstallments);

          let new_installments = studentInstallments.map((installment, i) => {
            let discountedAmount = 0;
            discount?.forEach((dis) => {
              let discountFeeHeadId = dis?.fee_head_id;
              let discountPercent = parseInt(dis?.percent) || 0;
              let discountAmount = parseInt(dis?.amount) || 0;

              let feeHeadIds = discountFeeHeadId;
              if (typeof feeHeadIds === "string") {
                try {
                  feeHeadIds = JSON.parse(feeHeadIds);
                } catch (e) {
                  if (feeHeadIds.startsWith("{") && feeHeadIds.endsWith("}")) {
                    feeHeadIds = feeHeadIds.slice(1, -1).split(",").map(s => s.trim());
                  } else {
                    feeHeadIds = [feeHeadIds.trim()];
                  }
                }
              }
              if (!Array.isArray(feeHeadIds)) {
                feeHeadIds = feeHeadIds ? [feeHeadIds] : [];
              }
              feeHeadIds = feeHeadIds
                .map(id => (typeof id === "object" && id !== null ? (id.fee_head_id || id.id || id.value) : id))
                .filter(id => {
                  const s = String(id || "").trim();
                  return s !== "" && s !== "null" && s !== "{}" && s !== "undefined";
                });

              const hasSpecificHeads = feeHeadIds.length > 0;
              let lineItemAmountByCategory = 0;
              let applicableDiscount = 0;

              if (hasSpecificHeads) {
                const matchedItems = (installment?.line_items || []).filter((li) =>
                  feeHeadIds.some((fId) => String(fId) === String(li.fee_head_master_id || li.fee_head_id))
                );
                if (matchedItems.length > 0) {
                  lineItemAmountByCategory = matchedItems.reduce(
                    (sum, item) => sum + (parseInt(item[categoryAmount] || item.amount || 0) || 0),
                    0
                  );
                  if (lineItemAmountByCategory > 0) {
                    if (discountAmount > 0) {
                      applicableDiscount = Math.min(discountAmount, lineItemAmountByCategory);
                    } else if (discountPercent > 0) {
                      applicableDiscount = Math.round((lineItemAmountByCategory * discountPercent) / 100);
                    }
                  }
                }
              } else {
                lineItemAmountByCategory = (installment?.line_items || []).reduce(
                  (sum, item) => sum + (parseInt(item[categoryAmount] || item.amount || 0) || 0),
                  0
                );
                if (lineItemAmountByCategory > 0) {
                  if (discountAmount > 0) {
                    applicableDiscount = Math.min(discountAmount, lineItemAmountByCategory);
                  } else if (discountPercent > 0) {
                    applicableDiscount = Math.round((lineItemAmountByCategory * discountPercent) / 100);
                  }
                }
              }

              discountedAmount += applicableDiscount;
            });

            const maxDiscount = parseInt(installment[feeCategory] || 0);
            discountedAmount = Math.min(maxDiscount, discountedAmount);

            console.log("discountedAmount--->>>", discountedAmount);

            return {
              orderno: i + 1,
              amount: installment[feeCategory],
              status: "pending",
              due_date: installment.due_date,
              month: installment.month,
              fee_master_installment_id: installment.fee_master_installment_id,
              session_id: globalSessionId,
              installment_discount: discountedAmount,
            };
          });

          console.log("new_installments==>>>", new_installments);

          return prev?.isPromote === true
            ? {
                ...prev,
                class_id: val.id,
                classname: val.class_name,
                prevClass: location?.state?.classname,
                prevClsId: location?.state?.class_id,
                section_id: null,
                fee_id: feeMatch?.id,
                fee_type: feeMatch?.type,
                installments: new_installments,
                promoted_class_id: val?.id,
                promoted_class_name: val?.class_name,
                promoted_section_id: null,
                promoted_section_name: null,
              }
            : prev;
          // }
        })
      );

      console.log("updatedSelecteStudents===>>>", updatedSelecteStudents);

      if (updatedSelecteStudents.some((student) => student === null)) {
        setIsNextBtton(true);
        setStudents(students); // Set old records as it is.
        return toast.error("Create fee master records first!!!");
      } else {
        setIsNextBtton(false);
        setStudents(updatedSelecteStudents);
      }
    } catch (error) {
      console.log("error-during-fatch-fee_master-by-clsID-->>", error);
      return toast.error(error?.response?.data?.message);
    }
  };

  const generateInstallmentDates = (start, end) => {
    const dates = [];
    let currentDate = new Date(start);

    while (currentDate <= end) {
      dates.push(new Date(currentDate));
      const monthName = currentDate.toLocaleString("default", {
        month: "long",
      });
      const formattedDate = currentDate.toISOString().split("T")[0];
      sessionDates[monthName] = formattedDate;
      currentDate.setMonth(currentDate.getMonth() + 1);

      if (currentDate.getDate() !== start.getDate()) {
        currentDate.setDate(0);
      }
    }

    if (dates[dates.length - 1] < end) {
      dates.push(new Date(end));
      const monthName = end.toLocaleString("default", { month: "long" });
      const formattedDate = end.toISOString().split("T")[0];
      sessionDates[monthName] = formattedDate;
    }

    return dates;
  };

  const getdiscount = async (id) => {
    const { result } = await schoolApi.fetchFeeDiscountLineItemsBySt(id);
    // console.log("result discount ->",result)
    return result;
  };

  const handleNext = async () => {
    try {
      if (students?.length === 0) {
        return toast.error("No record found!");
      }

      let countError = 0;
      for (let i = 0; i <= students.length - 1; i++) {
        if (!students[i]?.class_id || !students[i]?.section_id) {
          countError += 1;
          console.log(
            "students[" + i + "]?.class_id -->> ",
            students[i]?.class_id
          );
          console.log(
            "students[" + i + "]?.section_id -->> ",
            students[i]?.section_id
          );
          console.log(
            "students[" + i + "]?.isPromote -->> ",
            students[i]?.isPromote
          );
        }
      }

      if (countError > 0) {
        return toast.error("Missing required fields");
      }

      console.log("All Students' Records Are ready to Promote");
      navigate("/promotionView", { state: students });
    } catch (error) {
      console.error("An error occurred during handleNext:", error);
    }
  };

  const labels = {
    beforeSelect: " ",
  };

  const headers = [
    {
      title: (
        <div className="mx-3 promote-header">
          <Form.Check
            type="checkbox"
            className="student-result-switch fs-5"
            onChange={handleCheckbox}
            name="Master_checkbox"
            checked={
              students?.length > 0 &&
              students?.every((student) => student?.isPromote === true)
            }
            disabled={globalSessionId ? false : true}
          />
        </div>
      ),
      prop: "",
      cell: (row) => (
        <Form.Group className="mx-3 d-flex">
          <Form.Check
            type="checkbox"
            name="Child_checkbox"
            className="student-result-switch fs-5"
            id={`student_result_toggle_${row?.studentid}`}
            // label={row?.isPromote ? "Yes" : "No"}
            checked={row?.isPromote === true}
            disabled={globalSessionId ? false : true}
            onChange={(e) => {
              handleCheckbox(e, row);
            }}
          />
        </Form.Group>
      ),
    },
    { title: "Sr No", prop: "sr_no", isFilterable: true },
    { title: "Student Name", prop: "student_name", isFilterable: true },
    { title: "Parent Name", prop: "parent_name", isFilterable: true },
    {
      title: "Promote Class",
      prop: "",
      cell: (row) => (
        <Form.Group>
          <Form.Select
            disabled={globalSessionId ? (row?.isPromote ? false : true) : true}
            required
            name="each_class_id"
            value={
              row?.isPromote === false
                ? row?.class_id
                : row?.isPromote === true && row?.class_id
                ? row?.class_id
                : ""
            }
            onChange={(e) =>
              handleClass(
                promotedClasses?.find((obj) => obj?.id === e.target.value),
                row?.student_admission_id,
                e.target.name
              )
            }
          >
            <option value="" disabled>
              -- Select --
            </option>
            {promotedClasses?.map((vl, key) => (
              <option key={vl.id} value={vl.id}>
                {vl.class_name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      ),
    },
    {
      title: "Section",
      prop: "",
      cell: (row) => (
        <Form.Group>
          <Form.Select
            disabled={globalSessionId ? (row?.isPromote ? false : true) : true}
            required
            name="sectionid"
            value={
              row?.section_id && row?.isPromote === true
                ? row?.section_id
                : row?.section_id
                ? row?.section_id
                : ""
            }
            onChange={(e) => handleSection(e, row?.student_admission_id)}
          >
            <option value="">-- Select Section --</option>
            {row?.updated_row_section && row?.isPromote === true
              ? row?.updated_row_section?.map((vl, key) => (
                  <option key={vl.id} value={vl.id}>
                    {vl.name}
                  </option>
                ))
              : row?.isPromote === false
              ? classSection?.map((vl, key) => (
                  <option key={vl?.id} value={vl?.id}>
                    {vl?.name}
                  </option>
                ))
              : promoteSection.map((vl, key) => (
                  <option key={vl?.id} value={vl?.id}>
                    {vl?.name}
                  </option>
                ))}
          </Form.Select>
        </Form.Group>
      ),
    },
    {
      title: "Drop Out",
      prop: "",
      cell: (row) => (
        <Form.Group className="d-flex">
          <Form.Check
            type="switch"
            className="student-result-switch"
            id={`upcoming_session_toggle_${row?.studentid}`}
            label={row?.isDropout ? "Yes" : "No"}
            disabled={globalSessionId ? false : true}
            checked={row?.isDropout === true}
            onChange={(e) => {
              handleStudentDropOutStatus(row, e.target.checked);
            }}
          />
        </Form.Group>
      ),
    },
  ];

  // console.log("allClasses==>", allClasses);
  // console.log("classSection==>", classSection);
  // console.log("promoteSection==>", promoteSection);
  // console.log("sessionDates-->", sessionDates);
  // console.log("feeStructure-->", feeStructure);
  // console.log("sessionDates-->", sessionDates);
  // console.log("sessions-pawan->", sessions);
  // console.log("sectionByInlineClassId-->>", sectionByInlineClassId);
  console.log("students-pawan->", students);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>

      <Row className="g-0">
        <Col lg={2} className="mx-3">
          <Link className="nav-link mx-2" to="/">
            Home <i className="fa-solid fa-chevron-right"></i> Student Promotion
          </Link>
        </Col>
      </Row>

      <Row className="mx-3 d-flex mt-4">
        <Col lg={4}>
          <Form.Group className="w-75">
            <Form.Label>Current Class</Form.Label>
            <Form.Select
              required
              name="current_class"
              onChange={(e) => handleChange1(e)}
              value={promotionData?.current_class}
            >
              {allClasses.map((vl) => (
                <option key={vl.id} value={vl.id}>
                  {vl.class_name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col lg={4}>
          <Form.Group className="w-75">
            <Form.Label>Current Section</Form.Label>
            <Form.Select
              required
              name="current_section"
              onChange={(e) => handleChange1(e)}
              value={promotionData?.current_section}
            >
              <option value="" disabled selected>
                -- Select --
              </option>
              {classSection.map((vl) => (
                <option key={vl.id} value={vl.id}>
                  {vl.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col lg={3}>
          <Form.Group className="w-75">
            <Form.Label>Current Session</Form.Label>
            <Form.Select
              required
              name="current_session"
              onChange={(e) => handleChange1(e)}
              value={promotionData?.current_session}
            >
              <option value="" disabled selected>
                -- Select --
              </option>
              {sessions.map((vl) => (
                <option
                  key={vl.id}
                  value={vl.id}
                  disabled={vl.id === globalSessionId}
                >
                  {vl.year}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col lg={1}>
          <Button
            className="btn-light add-new-button"
            style={{ marginTop: "24px" }}
            variant=""
            onClick={handleStudentRecordsGet}
            disabled={students?.length > 0 ? true : false}
          >
            Search
          </Button>
        </Col>
      </Row>

      <hr className="divider my-3" />

      {showUpComingFields && (
        <Row className="mx-3 d-flex">
          <Col lg={4}>
            <Form.Group className="w-75">
              <Form.Label>Upcoming Session</Form.Label>
              <Form.Select
                disabled={students?.length > 0 ? false : true}
                name="promotion_session"
                required
                onChange={(e) => handleSession(e)}
                value={students?.length > 0 ? null : ""}
              >
                <option value="" disabled selected>
                  -- Select Session --
                </option>
                {sessions
                  ?.filter((vl) => vl?.year > currentSessionRecord?.year)
                  .map((vl) => (
                    <option key={vl?.id} value={vl.id}>
                      {vl?.year}
                    </option>
                  ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col lg={4}>
            <Form.Group className="w-75">
              <Form.Label>Promoted class</Form.Label>
              <Form.Select
                disabled={globalSessionId ? false : true}
                name="prmotd_class"
                onChange={(e) =>
                  handleSetPromoteCls(
                    promotedClasses?.find((obj) => obj.id === e.target.value)
                  )
                }
                value={students?.length > 0 ? null : ""}
              >
                <option value="" disabled selected>
                  -- Select --
                </option>
                {promotedClasses?.map((vl) => (
                  <option key={vl.id} value={vl.id}>
                    {vl.class_name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col lg={4}>
            <Form.Group className="w-75">
              <Form.Label>Promoted Section</Form.Label>
              <Form.Select
                disabled={globalSessionId ? false : true}
                name="prmotion_section"
                onChange={(e) => handleSection(e, null)}
                value={students?.length > 0 ? null : ""}
              >
                <option value="">-- Select --</option>
                {promoteSection &&
                  promoteSection?.map((vl) => (
                    <option key={vl.id} value={vl.id}>
                      {vl.name}
                    </option>
                  ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
      )}

      <Row
        className="mx-3 mt-4 py-2 px-3 text-light fw-bold"
        style={{ background: "grey" }}
      >
        <h5 className="mb-0">Student List</h5>
      </Row>

      <Row className="mx-2 mt-3">
        <DatatableWrapper
          body={students || location.state.promotionRecord}
          headers={headers}
          paginationOptionsProps={{
            initialState: {
              rowsPerPage: 10,
              options: [5, 10, 15, 20],
            },
          }}
        >
          <Row className="mb-4">
            <Col
              xs={12}
              lg={4}
              className="d-flex flex-col justify-content-end align-items-end"
            >
              <Filter />
            </Col>
            <Col
              xs={12}
              sm={6}
              lg={4}
              className="d-flex flex-col justify-content-lg-center align-items-center justify-content-sm-start mb-2 mb-sm-0"
            >
              <PaginationOptions labels={labels} />
              <div style={{ marginTop: "5px" }}>
                <InfoPill left="Total Student" right={students?.length} />
              </div>
            </Col>
            <Col
              xs={12}
              sm={6}
              lg={4}
              className="d-flex flex-col justify-content-end align-items-end"
            >
              {
                <Button
                  variant=""
                  className="btn-light add-new-button"
                  disabled={globalSessionId ? false : true}
                  onClick={handleNext}
                >
                  Next
                </Button>
              }
            </Col>
          </Row>
          <Table striped responsive className="promotionTable">
            <TableHeader />
            {students?.length > 0 ||
            location?.state?.promotionRecord?.length > 0 ? (
              <TableBody />
            ) : (
              <TableBody>
                <tr>
                  <td colSpan={7} className="text-center">
                    No Records Found!!!
                  </td>
                </tr>
              </TableBody>
            )}
          </Table>
          <Row>
            <div
              xs={12}
              sm={6}
              lg={4}
              className="d-flex flex-col justify-content-center align-items-center"
            >
              <Pagination />
            </div>
          </Row>
        </DatatableWrapper>
      </Row>
    </>
  );
};
export default Promotion;
